import { FC } from "react";

export const EditIcon: FC = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="#343A40"
        fillRule="evenodd"
        d="M12.667 1.947a1.386 1.386 0 0 0-.98.406L2.781 11.26l-.735 2.695 2.695-.735 8.906-8.906a1.385 1.385 0 0 0-.98-2.366Zm-.913-.818a2.386 2.386 0 0 1 2.6 3.89l-9 9a.5.5 0 0 1-.222.13l-3.667 1a.5.5 0 0 1-.614-.614l1-3.667a.5.5 0 0 1 .129-.222l9-9c.221-.222.484-.397.774-.517Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
  );
};
